<div class="messaged-modal-spinner-container">
  <mat-spinner [diameter]="60"></mat-spinner>
  @if (message) {
    <div class="message">{{message}}</div>
  }
</div>
